export default "__VITE_ASSET__f3e62370__"